import React, { Fragment } from "react";
import moment from "moment";
import {
  TypographyT40,
  TypographyT43,
  TypographyT41,
  TypographyT42,
  TypographyT59,
  TypographyT61
} from "Components/Common/Typography/index";
import {
  TBody,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
import {
  ButtonT10,
  ButtonT11,
  ButtonT12,
  ButtonT3,
  IconButtonT1,
} from "Components/Common/Button/index";
import { ReactComponent as EditIcon } from "Icons/edit.svg";
import { ReactComponent as InfoIcon } from 'Icons/info.svg';
import { getToFixedValue, isDesmet, isDesmetSupplier } from "Utils/index";
import { Spacer } from "Components/Common/Spacer/index";
const InfoDetailsTable = (props) => {
  const {
    contractsDetailsList = [],
    handleOnClickForViewMaterials,
    handleOnClickCreateRequest,
    handleOnClickForEditRFQRequest,
    activeStatusTabBtnId,
    handleOnClickVehicleDetails
  } = props;

  const shouldRenderEditIconColumn = () => {
    const C1 = isDesmetSupplier();
    const C2 = activeStatusTabBtnId === 2 || activeStatusTabBtnId === 1;
    if (C1 && C2) {
      return true;
    }
    return false;
  };
  const shouldRenderCreateRFQColumn = () => {
    const C1 = !isDesmetSupplier();
    const C2 = activeStatusTabBtnId === 2;
    if (C1 && C2) {
      return true;
    }
    return false;
  };

  const shouldRenderRFQNoAndDateColumn = () => {
    const C1 = activeStatusTabBtnId === 3 || activeStatusTabBtnId === 5;
    if (C1) {
      return true;
    }
    return false;
  };

  const shouldRenderTransporterDetailsColumns = () => {
    const C1 = activeStatusTabBtnId === 5;
    if (C1) {
      return true;
    }
    return false;
  };

  const shouldRenderSupplierNameColumn = () => {
    const C1 = !isDesmetSupplier();
    if (C1) {
      return true;
    }
    return false;
  };

  const getTransporterNameList = (ele = {}) => {
    let transporterNameList = [];
    transporterNameList = (ele.loi_accepted_transporters || []).map((ele) => {
      return ele.name;
    });
    return transporterNameList;
  };

  const getTransporterContactPersonNameList = (ele = {}) => {
    let transporterContactPersonNameList = [];
    transporterContactPersonNameList = (
      ele.loi_accepted_transporters || []
    ).map((ele) => {
      return ele.contact_name;
    });
    return transporterContactPersonNameList;
  };

  const getTransporterContactNoList = (ele = {}) => {
    let transporterContactNoList = [];
    transporterContactNoList = (ele.loi_accepted_transporters || []).map(
      (ele) => {
        return ele.contact_no;
      }
    );
    return transporterContactNoList;
  };

  const isEditBtnDisabled = (ele) => {
    const C1 = activeStatusTabBtnId === 2;
    const C2 = !!ele.rfq_create_progress;

    if (C1 && C2) {
      return true;
    }

    return false;
  };

  const getVehicleType = (ele) => {
    let vehicle = [];
    (ele.loi_accepted_transporters || []).map(el => {
      if(el.transporter_vehicle) {
        vehicle.push(el.transporter_vehicle.length > 1 ? 'Multiple Vehicle' : (el.transporter_vehicle[0] || {}).name)
      }
    });
    return vehicle;
  }

  const getTotalPrice = (ele) => {
    let totalPrice = [];
    (ele.loi_accepted_transporters || []).map(el => {
      if(el.transporter_vehicle) {
        totalPrice.push((el.transporter_vehicle || []).reduce((sum, item) => sum += Number(item.price || 0), 0));
      }
    });
    return totalPrice;
  }

  return (
    <Fragment>
      <TableWrapper style={{ height: `calc(100vh - ${isDesmetSupplier() ? '196px' : '180px'})` }}>
        <Table>
          <THead>
            <Tr>
              <Th>Req No.</Th>
              <Th>Request Created Date</Th>
              <Th>Pick Up Location</Th>
              {shouldRenderRFQNoAndDateColumn() && (
                <Fragment>
                  <Th>RFQ No.</Th>
                  <Th>RFQ Date </Th>
                </Fragment>
              )}
              {shouldRenderSupplierNameColumn() && <Th>Name of Supplier</Th>}
              <Th>Project ID</Th>
              <Th>PO No.</Th>
              <Th>Gross Weight(Kg)</Th>
              <Th>Net Weight (Kg)</Th>
              <Th>Vol (m3)</Th>
              <Th>Pickup Date</Th>
              <Th>Recommended Vehicle</Th>
              <Th>Supplier Contact Person Name</Th>
              <Th>Supplier Contact No.</Th>
              {shouldRenderTransporterDetailsColumns() && (
                <Fragment>
                  <Th>Transporter Name</Th>
                  <Th>Transporter Contact Person Name</Th>
                  <Th>Transporter Contact No.</Th>
                  <Th>Vehicle Type</Th>
                  <Th>Price</Th>
                </Fragment>
              )}
              <Th>Materials</Th>
              {(shouldRenderEditIconColumn() ||
                shouldRenderCreateRFQColumn()) && <Th></Th>}
            </Tr>
          </THead>
          <TBody>
            {contractsDetailsList.map((ele, ind) => {
              return (
                <Fragment key={ind}>
                  <Tr>
                    <Td>
                      <TypographyT61 style={{ width: "max-content" }}>
                        {ele.supplier_number || "-"}
                      </TypographyT61>
                      {!!ele.rfq_cancelled_updated && (
                        <Fragment>
                          <Spacer spacing={"2px"} />
                          <TypographyT59>Cancelled</TypographyT59>
                        </Fragment>
                      )}
                    </Td>
                    <Td>
                      <TypographyT61>
                        {!!ele.created
                          ? moment(ele.created).format(
                            "DD/MM/YYYY"
                          )
                          : "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {!!ele.consignor_details
                          ? ele.consignor_details.location
                          : "-"}
                      </TypographyT61>
                    </Td>
                    {shouldRenderRFQNoAndDateColumn() && (
                      <Fragment>
                        <Td>
                          <TypographyT61 style={{ width: "max-content" }}>
                            {ele.rfq_number || "-"}
                          </TypographyT61>
                        </Td>
                        <Td>
                          <TypographyT61>
                            {!!ele.rfq_created_date
                              ? moment(ele.rfq_created_date).format(
                                  "DD/MM/YYYY"
                                )
                              : "-"}
                          </TypographyT61>
                        </Td>
                      </Fragment>
                    )}
                    {shouldRenderSupplierNameColumn() && (
                      <Td>
                        <TypographyT61>
                          {/* {ele.consignor_details.consignor_name || "-"} */}
                          {ele.floated_by || "-"}
                        </TypographyT61>
                      </Td>
                    )}
                    <Td>
                      <TypographyT61>
                        {ele.project_details.project_id || "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {ele.project_details.po_number || "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {ele.total_gross_weight || "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {ele.total_net_weight || "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>{getToFixedValue(ele.total_volume) || "-"}</TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {!!ele.tentative_pickup_date
                          ? moment(ele.tentative_pickup_date).format(
                              "DD/MM/YYYY"
                            )
                          : "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {ele.vehicle_details.vehicle_type_name || "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {ele.contact_details.contact_person_name || "-"}
                      </TypographyT61>
                    </Td>
                    <Td>
                      <TypographyT61>
                        {ele.contact_details.contact_no || "-"}
                      </TypographyT61>
                    </Td>

                    {shouldRenderTransporterDetailsColumns() && (
                      <Fragment>
                        <Td>
                          {getTransporterNameList(ele).map((eleTN, index) => {
                            return (
                              <Fragment>
                                <TypographyT61>
                                  {getTransporterNameList(ele).length - 1 !==
                                  index
                                    ? `${eleTN},`
                                    : `${eleTN}.`}
                                </TypographyT61>
                              </Fragment>
                            );
                          })}
                        </Td>
                        <Td>
                          {getTransporterContactPersonNameList(ele).map(
                            (eleCP, index) => {
                              return (
                                <Fragment>
                                  <TypographyT61>
                                    {getTransporterContactPersonNameList(ele)
                                      .length -
                                      1 !==
                                    index
                                      ? `${eleCP},`
                                      : `${eleCP}.`}
                                  </TypographyT61>
                                </Fragment>
                              );
                            }
                          )}
                        </Td>
                        <Td>
                          {getTransporterContactNoList(ele).map(
                            (eleCN, index) => {
                              return (
                                <Fragment>
                                  <TypographyT61>
                                    {getTransporterContactNoList(ele).length -
                                      1 !==
                                    index
                                      ? `${eleCN},`
                                      : `${eleCN}.`}
                                  </TypographyT61>
                                </Fragment>
                              );
                            }
                          )}
                        </Td>
                        <Td>
                            {(ele.loi_accepted_transporters || []).length > 0 && 
                              <>
                                {getVehicleType(ele).map((eleTN, index) => {
                                  return (
                                    <Fragment>
                                      <TypographyT61>
                                        {eleTN}
                                        <InfoIcon className="curP" onClick={() => handleOnClickVehicleDetails(ele.loi_accepted_transporters)}/>
                                      </TypographyT61>
                                    </Fragment>
                                  );
                                })}
                              </>
                            }
                        </Td>
                        <Td>
                        {(ele.loi_accepted_transporters || []).length > 0 && 
                              <>
                                {getTotalPrice(ele).map((eleTN, index) => {
                                  return (
                                    <Fragment>
                                      <TypographyT61>
                                        {eleTN}
                                      </TypographyT61>
                                    </Fragment>
                                  );
                                })}
                              </>
                            }
                        </Td>
                      </Fragment>
                    )}
                 
                    <Td>
                      <ButtonT11
                        onClick={() => {
                          handleOnClickForViewMaterials(
                            ele.material_packing_list
                          );
                        }}
                      >
                        View Materials
                      </ButtonT11>
                    </Td>

                    {shouldRenderEditIconColumn() && (
                      <Td>
                        <IconButtonT1
                          disabled={isEditBtnDisabled(ele)}
                          onClick={() => {
                            handleOnClickForEditRFQRequest(ele);
                          }}
                        >
                          <EditIcon width={"20px"} height={"20px"} />
                        </IconButtonT1>
                      </Td>
                    )}

                    {shouldRenderCreateRFQColumn() && (
                      <Td>
                        <ButtonT12
                          onClick={() => {
                            handleOnClickCreateRequest(ele);
                          }}
                        >
                          Create RFQ
                        </ButtonT12>
                      </Td>
                    )}
                  </Tr>
                </Fragment>
              );
            })}
          </TBody>
        </Table>
      </TableWrapper>
    </Fragment>
  );
};

export default InfoDetailsTable;
